export default __webpack_public_path__ + "static/media/magon-outside2.4a35a8b3.jpg";